import { PlusInSquareIcon } from "assets/icons";
import { useBoolean } from "hooks";
import { useState } from "react";
import { Button, Pagination, SearchInput } from "ui";

import {
  DeleteCouponModal,
  CouponModal,
  SharingsCouponsTable
} from "../../components";
import { CouponType } from "../../constants";
import { useCouponsList } from "../../hooks";

import styles from "./SharingCoupons.module.scss";

const SharingCoupons = () => {
  const {
    coupons,
    totalItems,
    searchValue,
    page,
    isLoading,
    sorting,
    setSorting,
    setSearchValue,
    setPage
  } = useCouponsList(CouponType.SharingCoupon);

  const [deletingCouponId, setDeletingCouponId] = useState<string | null>(null);
  const {
    value: isCouponModalOpen,
    setTrue: openCouponModal,
    setFalse: closeCouponModal
  } = useBoolean(false);

  return (
    <>
      <div className={styles.headerLine}>
        <SearchInput
          value={searchValue}
          onChange={setSearchValue}
          placeholder={"Search..."}
        />

        <Button
          title={"New Coupon"}
          icon={<PlusInSquareIcon />}
          onClick={openCouponModal}
        />
      </div>

      <SharingsCouponsTable
        coupons={coupons}
        sorting={sorting}
        setSorting={setSorting}
        isLoading={isLoading}
        onDeleteCoupon={setDeletingCouponId}
      />

      <Pagination
        currentPage={page}
        onChange={setPage}
        totalItems={totalItems}
      />

      <CouponModal
        couponType={CouponType.SharingCoupon}
        isOpen={isCouponModalOpen}
        onClose={closeCouponModal}
      />

      {deletingCouponId && (
        <DeleteCouponModal
          id={deletingCouponId}
          isOpen={!!deletingCouponId}
          couponType={CouponType.SharingCoupon}
          onClose={() => setDeletingCouponId(null)}
        />
      )}
    </>
  );
};

export default SharingCoupons;
